import React from 'react';
import { Box, FormControl, FormLabel, Select, Flex } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { KPIOption } from 'src/features/Settings/types';

type KPISelectorProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onReset: () => void;
  options: KPIOption[];
  placeholder: string;
  disabled?: boolean;
  isLoading?: boolean;
};

export const KPISelector: React.FC<KPISelectorProps> = ({
  label,
  value,
  onChange,
  onReset,
  options,
  placeholder,
  disabled = false,
  isLoading = false,
}) => {
  return (
    <Box
      flex={1}
      border="1px solid"
      borderColor={value ? 'icon.green' : 'border.lightGreen'}
      borderRadius="12px"
      pt={4}
      pb={2}
      bg="surface.card">
      <FormControl>
        <FormLabel fontSize="18px" fontWeight={600} mb={3} px={6}>
          {label}
        </FormLabel>
        <Flex position="relative" align="center">
          <Select
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            bg="surface.card"
            h="40px"
            px={2}
            border="1px solid"
            borderColor="transparent"
            outline="none"
            fontSize="14px"
            color={value ? 'text.title' : 'gray.400'}
            icon={value ? <Box display="none" /> : undefined}
            disabled={disabled || isLoading}
            sx={{
              '& > option': {
                color: 'text.body',
              },
            }}
            _disabled={{
              opacity: 1,
              color: 'gray.400',
              cursor: 'not-allowed',
            }}
            _focus={{
              borderColor: 'icon.green',
              boxShadow: '0 0 0 1px var(--chakra-colors-icon-green)',
            }}>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
          {value && (
            <Box
              position="absolute"
              right="12px"
              onClick={onReset}
              p={1}
              cursor="pointer"
              _hover={{ bg: 'surface.hover' }}
              borderRadius="md"
              zIndex={1}
              display="flex"
              alignItems="center"
              justifyContent="center">
              <Icon iconName="close" width={3} height={3} />
            </Box>
          )}
        </Flex>
      </FormControl>
    </Box>
  );
};
